const RESET_STATE = 'RESET_STATE';

export const initialState = {
  cashAnnouncementList: false,
  cashNewsList: false,
  cashNewsSetting: false,
  cashRoleList: false,
  cashUserList: false,
  cashUserByEmailId: "",
  cashAgendaFilter: "",
  cashDirectoryList: false,
  cashedDocumentsList: false,
  cashAgendaListForDocument: false,
  cashMeetingListForDocument: false,
  cashMeetingId: "",
  cashUserEmail: "",
  cashFilter: "",
  cashCalendarFilter: "",
  cashPepleUserList: false,
  cashSurveyList: false,
  cashTasksList: false,
  cashTenantConfigList: false,
  cashMasterConfigList: false,
  cashUser: false,
  cashAccessPermission: false,
  cashWidgetList: false,
  cashAgendaList: false,
  cashRoleId: false,
  cashUserId: false,
};

const state = { ...initialState };

const mutations = {
  setCashWidgetList(state, data) {
    state.cashWidgetList = data;
  },

  setCashUser(state, data) {
    state.cashUser = data;
  },

  setCashAccessPermission(state, data) {
    state.cashAccessPermission = data;
  },

  setCashTenantConfigList(state, data) {
    state.cashTenantConfigList = data;
  },

  setCashMasterConfigList(state, data) {
    state.cashMasterConfigList = data;
  },

  setCashTasksList(state, data) {
    state.cashTasksList = data;
  },

  setCashSurveyList(state, data) {
    state.cashSurveyList = data;
  },

  setCashPepleUserList(state, data) {
    state.cashPepleUserList = data;
  },

  setCashAgendaFilter(state, data) {
    state.cashAgendaFilter = data;
  },

  setCashCalendarFilter(state, data) {
    state.cashCalendarFilter = data;
  },

  setCashedDocumentsList(state, data) {
    state.cashedDocumentsList = data;
  },

  setCashAgendaListForDocument(state, data) {
    state.cashAgendaListForDocument = data;
  },

  setCashMeetingListForDocument(state, data) {
    state.cashMeetingListForDocument = data;
  },

  setCashMeetingId(state, data) {
    state.cashMeetingId = data;
  },

  setCashUserEmail(state, data) {
    state.cashUserEmail = data;
  },

  setCashAnnouncementList(state, data) {
    state.cashAnnouncementList = data;
  },

  setCashNewsList(state, data) {
    state.cashNewsList = data;
  },

  setCashNewsSetting(state, data) {
    state.cashNewsSetting = data;
  },

  setCashRoleList(state, data) {
    state.cashRoleList = data;
  },

  setCashUserList(state, data) {
    state.cashUserList = data;
  },

  setCashUserByEmailId(state, data) {
    state.cashUserByEmailId = data;
  },

  setCashFilter(state, data) {
    state.cashFilter = data;
  },

  setCashDirectoryList(state, data) {
    state.cashDirectoryList = data;
  },

  setCashAgendaList(state, data) {
    state.cashAgendaList = data;
  },
  setCashRoleId(state, data) {
    state.cashRoleId = data;
  },

  setCashUserId(state, data) {
    state.cashUserId = data;
  },

  [RESET_STATE](state) {
    Object.assign(state, initialState);
  },
};

const actions = {
  resetState({ commit }) {
    commit(RESET_STATE);
  },
}

const getters = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
